(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  // Rotates the promo messages on mobile. On desktop all three are visible and
  // this does nothing, so it is gated on the arrows actually being displayed.
  function initAnnouncement() {
    const bar = document.querySelector('[data-announcement]');
    if (!bar || bar.dataset.ready) return;
    bar.dataset.ready = 'true';

    const messages = Array.from(bar.querySelectorAll('.announcement__message'));
    if (messages.length < 2) return;

    let index = 0;
    const show = (next) => {
      index = (next + messages.length) % messages.length;
      messages.forEach((m, i) => m.classList.toggle('announcement__message--current', i === index));
    };

    bar.querySelector('[data-announcement-prev]').addEventListener('click', () => show(index - 1));
    bar.querySelector('[data-announcement-next]').addEventListener('click', () => show(index + 1));
    show(0);

    // Auto-advance, paused for anyone who asked for less motion and while the
    // tab is hidden.
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let timer = null;
    const tick = () => {
      // The arrows are only laid out where one message shows at a time, so
      // their visibility is what says whether rotating is on right now.
      const rotating = getComputedStyle(bar.querySelector('.announcement__step')).display !== 'none';
      if (rotating && !reduced.matches && !document.hidden) show(index + 1);
    };
    const interval = Number(bar.dataset.interval) || 5000;
    const start = () => { timer = window.setInterval(tick, interval); };
    const stop = () => { window.clearInterval(timer); };
    start();
    bar.addEventListener('pointerenter', stop);
    bar.addEventListener('pointerleave', start);
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnnouncement);
  } else {
    initAnnouncement();
  }
  document.addEventListener('shopify:section:load', initAnnouncement);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    
  function enhanceArticle() {
    const body = document.querySelector('[data-article-body]');
    const bar = document.querySelector('[data-progress-bar]');

    if (bar && body && !bar.dataset.ready) {
      bar.dataset.ready = 'true';
      const update = () => {
        const start = body.offsetTop;
        const span = body.offsetHeight - window.innerHeight;
        const done = span > 0 ? (window.scrollY - start) / span : 0;
        bar.style.width = Math.min(100, Math.max(0, done * 100)) + '%';
      };
      document.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    const toc = document.querySelector('[data-toc]');
    const list = document.querySelector('[data-toc-list]');
    if (!toc || !list || !body || toc.dataset.ready) return;
    toc.dataset.ready = 'true';

    const headings = Array.from(body.querySelectorAll('h2, h3'));
    if (headings.length < 2) {
      // Nothing worth listing — leave the rail hidden so the column collapses.
      document.querySelector('.article')?.classList.add('article--no-toc');
      return;
    }

    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = 'section-' + index;
      const link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent;
      list.appendChild(link);
    });
    toc.hidden = false;

    const tocToggle = toc.querySelector('[data-toc-toggle]');
    if (tocToggle) {
      const setOpen = (open) => {
        toc.toggleAttribute('data-open', open);
        tocToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        const sign = tocToggle.querySelector('.toc__chevron');
        if (sign) sign.textContent = open ? '\u2212' : '+';
      };
      setOpen(window.innerWidth >= 750);
      tocToggle.addEventListener('click', () => setOpen(!toc.hasAttribute('data-open')));
      tocToggle.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setOpen(!toc.hasAttribute('data-open'));
        }
      });
    }

    // IntersectionObserver only fires while a heading sits inside a narrow
    // band, so nothing was marked whenever the reader was between two of them.
    // Tracking the last heading scrolled past always resolves to exactly one.
    const links = Array.from(list.querySelectorAll('a'));
    const markCurrent = () => {
      let activeIndex = 0;
      headings.forEach((heading, index) => {
        if (heading.getBoundingClientRect().top <= 120) activeIndex = index;
      });
      links.forEach((link, index) => {
        link.classList.toggle('toc--current', index === activeIndex);
      });
      const active = links[activeIndex];
      if (active && active.offsetParent) {
        const rail = active.parentElement;
        const top = active.offsetTop - rail.clientHeight / 2;
        if (rail.scrollHeight > rail.clientHeight) rail.scrollTo({ top, behavior: 'smooth' });
      }
    };

    document.addEventListener('scroll', markCurrent, { passive: true });
    markCurrent();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceArticle);
  } else {
    enhanceArticle();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  function initCartDrawer() {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer || drawer.dataset.ready) return;
    drawer.dataset.ready = 'true';

    const panel = drawer.querySelector('.cart-drawer__panel');
    const body = drawer.querySelector('[data-cart-body]');
    const sectionId = 'cart-drawer';
    let lastFocused = null;

    const setOpen = (open) => {
      drawer.hidden = !open;
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) {
        lastFocused = document.activeElement;
        panel.focus();
      } else if (lastFocused && lastFocused.focus) {
        lastFocused.focus();
      }
    };

    // Re-renders the drawer from the server rather than patching the DOM by
    // hand, so discounts, meters and totals stay whatever Liquid says they are.
    const refresh = async () => {
      body.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(`${window.Shopify.routes.root}?section_id=${sectionId}`);
        const markup = await response.text();
        const fresh = new DOMParser().parseFromString(markup, 'text/html');
        const freshBody = fresh.querySelector('[data-cart-body]');
        if (freshBody) body.innerHTML = freshBody.innerHTML;

        const count = fresh.querySelector('[data-cart-count]');
        if (count) {
          document.querySelectorAll('[data-cart-count]').forEach((el) => {
            el.textContent = count.textContent;
          });
        }
      } finally {
        body.removeAttribute('aria-busy');
      }
    };

    // Header cart button opens the drawer instead of navigating.
    document.querySelectorAll('[data-cart-toggle]').forEach((el) => {
      el.addEventListener('click', (event) => {
        event.preventDefault();
        setOpen(true);
      });
    });

    drawer.querySelectorAll('[data-cart-close]').forEach((el) => {
      el.addEventListener('click', () => setOpen(false));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !drawer.hidden) setOpen(false);
    });

    // "KENDİ SETİN" card: quantity, removal and edit act on every line of the set.
    body.addEventListener('click', async (event) => {
      const group = event.target.closest('[data-set-group]');
      if (!group) return;
      const step = event.target.closest('[data-set-step]');
      const remove = event.target.closest('[data-set-remove]');
      const edit = event.target.closest('[data-set-edit]');
      if (edit) {
        try {
          sessionStorage.setItem('cpl-set-edit', JSON.stringify({
            id: edit.dataset.setEdit,
            qty: Number(group.dataset.setQty) || 1,
            variants: (edit.dataset.setVariants || '').split(',').filter(Boolean),
          }));
        } catch (e) {
          // Storage blocked: the link still opens the set builder.
        }
        const builder = document.querySelector('set-builder');
        if (builder && typeof builder.loadEdit === 'function') {
          event.preventDefault();
          setOpen(false);
          builder.loadEdit();
          builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        return;
      }
      if (!step && !remove) return;
      event.preventDefault();
      const qty = remove ? 0 : Math.max(0, Number(group.dataset.setQty) + Number(step.dataset.setStep));
      const updates = {};
      (group.dataset.setKeys || '').split(',').filter(Boolean).forEach((key) => {
        updates[key] = qty;
      });
      body.setAttribute('aria-busy', 'true');
      await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      });
      await refresh();
    });

    // Other scripts (the set builder) add through the API, then ask the drawer
    // to redraw itself and open.
    document.addEventListener('cart:refresh', async (event) => {
      await refresh();
      if (event.detail && event.detail.open) setOpen(true);
    });

    // Quantity steppers and remove links inside the freshly rendered body.
    body.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-cart-change]');
      if (!button) return;
      event.preventDefault();

      body.setAttribute('aria-busy', 'true');
      await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line: Number(button.dataset.cartChange),
          quantity: Number(button.dataset.quantity),
        }),
      });
      await refresh();
    });

    // Any product form on the page adds through the API and opens the drawer.
    document.addEventListener('submit', async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.getAttribute('action') !== `${window.Shopify.routes.root}cart/add`) return;

      event.preventDefault();
      const submit = form.querySelector('[type="submit"]');
      if (submit) submit.disabled = true;

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });

        if (!response.ok) {
          // Sold out mid-session, or a variant the form no longer knows about:
          // let Shopify render its own error page rather than failing silently.
          form.submit();
          return;
        }

        await refresh();
        setOpen(true);
      } finally {
        if (submit) submit.disabled = false;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDrawer);
  } else {
    initCartDrawer();
  }
  document.addEventListener('shopify:section:load', initCartDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  // Without this the steppers are inert and shoppers use the number field plus
  // the update button, which is why that button ships visible.
  function enhanceCart(scope) {
    const root = scope || document;
    const form = root.querySelector('[data-cart-form]');
    if (!form || form.dataset.ready) return;
    form.dataset.ready = 'true';

    const updateButton = form.querySelector('[data-cart-update]');
    if (updateButton) updateButton.hidden = true;

    // "KENDİ SETİN" card: the whole set changes together, then the page reloads
    // so totals stay whatever Shopify says they are.
    form.addEventListener('click', async (event) => {
      const group = event.target.closest('[data-set-group]');
      if (!group) return;
      const edit = event.target.closest('[data-set-edit]');
      if (edit) {
        try {
          sessionStorage.setItem('cpl-set-edit', JSON.stringify({
            id: edit.dataset.setEdit,
            qty: Number(group.dataset.setQty) || 1,
            variants: (edit.dataset.setVariants || '').split(',').filter(Boolean),
          }));
        } catch (e) {
          // Storage blocked: the link still opens the set builder.
        }
        return;
      }
      const step = event.target.closest('[data-set-step]');
      const remove = event.target.closest('[data-set-remove]');
      if (!step && !remove) return;
      event.preventDefault();
      const qty = remove ? 0 : Math.max(0, Number(group.dataset.setQty) + Number(step.dataset.setStep));
      const updates = {};
      (group.dataset.setKeys || '').split(',').filter(Boolean).forEach((key) => {
        updates[key] = qty;
      });
      group.setAttribute('aria-busy', 'true');
      await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      });
      window.location.reload();
    });

    form.addEventListener('click', (event) => {
      const button = event.target.closest('[data-step]');
      if (!button) return;

      const input = form.querySelector('#' + button.dataset.target);
      if (!input) return;

      const next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(button.dataset.step, 10));
      if (String(next) === input.value) return;

      input.value = next;
      form.requestSubmit ? form.requestSubmit(updateButton) : form.submit();
    });

    // Typing a quantity commits on blur rather than on every keystroke.
    form.addEventListener('change', (event) => {
      if (event.target.type !== 'number') return;
      form.requestSubmit ? form.requestSubmit(updateButton) : form.submit();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhanceCart());
  } else {
    enhanceCart();
  }
  document.addEventListener('shopify:section:load', (event) => enhanceCart(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  // Progressive enhancement only: without this the form still submits via its
  // apply button and "load more" is a normal link to the next page.
  function enhanceCollection(scope) {
    const root = scope || document;

    const filterForm = root.querySelector('[data-filter-form]');
    if (filterForm && !filterForm.dataset.ready) {
      filterForm.dataset.ready = 'true';
      const apply = filterForm.querySelector('[data-filter-apply]');
      if (apply) apply.hidden = true;

      // An untouched price field would otherwise submit as an empty
      // `filter.v.price.gte=` and clutter every filtered URL.
      const submitClean = () => {
        filterForm.querySelectorAll('input[type="number"]').forEach((input) => {
          input.disabled = input.value === '';
        });
        filterForm.submit();
      };

      filterForm.addEventListener('change', (event) => {
        // Price inputs commit on their own timer, not on every keystroke.
        if (event.target.type === 'number') return;
        submitClean();
      });
      filterForm.addEventListener('input', (event) => {
        if (event.target.type !== 'number') return;
        clearTimeout(filterForm.priceTimer);
        filterForm.priceTimer = setTimeout(submitClean, 700);
      });
      filterForm.addEventListener('submit', () => {
        filterForm.querySelectorAll('input[type="number"]').forEach((input) => {
          input.disabled = input.value === '';
        });
      });
    }

    const sortForm = root.querySelector('[data-sort-form]');
    if (sortForm && !sortForm.dataset.ready) {
      sortForm.dataset.ready = 'true';
      sortForm.addEventListener('change', () => sortForm.submit());
    }

    const chain = root.querySelector('[data-availability-chain]');
    if (chain && !chain.dataset.ready) {
      chain.dataset.ready = 'true';
      new AvailabilityChain(chain);
    } else {
      bindPlainLoadMore(root);
    }
  }

  // Plain "load more" for pages the chain does not drive (a shopper's own
  // availability filter, or any page reached directly).
  function bindPlainLoadMore(root) {
    const more = root.querySelector('[data-load-more]');
    if (!more || more.dataset.ready) return;
    more.dataset.ready = 'true';

    more.addEventListener('click', async (event) => {
      event.preventDefault();
      const grid = root.querySelector('[data-product-grid]');
      if (!grid) return;
      more.setAttribute('aria-busy', 'true');
      try {
        const doc = await fetchDocument(more.href);
        doc.querySelectorAll('[data-product-grid] > *').forEach((tile) => grid.appendChild(tile));
        const nextMore = doc.querySelector('.more');
        const currentMore = more.closest('.more');
        if (nextMore && currentMore) {
          currentMore.replaceWith(nextMore);
          bindPlainLoadMore(root);
        } else if (currentMore) {
          currentMore.remove();
        }
      } catch (error) {
        window.location.href = more.href;
      }
    });
  }

  async function fetchDocument(url) {
    const response = await fetch(url);
    if (!response.ok) throw new Error(response.status);
    return new DOMParser().parseFromString(await response.text(), 'text/html');
  }

  /**
   * Walks the collection in two Shopify-filtered passes — in stock, then sold
   * out — so the combined list is ordered across the whole collection rather
   * than within a single page.
   */
  class AvailabilityChain {
    constructor(root) {
      this.root = root;
      this.grid = root.querySelector('[data-product-grid]');
      this.base = root.dataset.collectionUrl;
      this.sort = root.dataset.sort;
      this.total = parseInt(root.dataset.total, 10) || 0;
      this.phase = 'in';
      this.page = 1;
      this.shown = 0;
      if (!this.grid) return;
      this.replaceFirstPage();
    }

    url(phase, page) {
      const params = new URLSearchParams();
      params.set('filter.v.availability', phase === 'in' ? '1' : '0');
      if (this.sort) params.set('sort_by', this.sort);
      if (page > 1) params.set('page', String(page));
      return this.base + '?' + params.toString();
    }

    // The server rendered the unfiltered page. Swap in the in-stock-only first
    // page so nothing sold out appears before an available product.
    async replaceFirstPage() {
      this.grid.setAttribute('aria-busy', 'true');
      try {
        const doc = await fetchDocument(this.url('in', 1));
        const tiles = doc.querySelectorAll('[data-product-grid] > *');
        if (tiles.length === 0) return this.advance();
        this.grid.replaceChildren(...tiles);
        this.shown = tiles.length;
        this.seen = null;
        this.render();
      } catch (error) {
        // Leave the server-rendered page in place and fall back to plain paging.
        bindPlainLoadMore(this.root);
      } finally {
        this.grid.removeAttribute('aria-busy');
      }
    }

    async loadMore() {
      // Without this, a double click (or an impatient one during a slow
      // request) starts a second run against the same cursor and appends the
      // same page twice.
      if (this.loading) return;
      this.loading = true;

      const button = this.root.querySelector('[data-load-more]');
      if (button) button.setAttribute('aria-busy', 'true');

      let next = { phase: this.phase, page: this.page + 1 };
      try {
        let doc = await fetchDocument(this.url(next.phase, next.page));
        let tiles = Array.from(doc.querySelectorAll('[data-product-grid] > *'));

        // In-stock pages exhausted: continue into the sold-out pass.
        if (tiles.length === 0 && next.phase === 'in') {
          next = { phase: 'out', page: 1 };
          doc = await fetchDocument(this.url(next.phase, next.page));
          tiles = Array.from(doc.querySelectorAll('[data-product-grid] > *'));
        }

        tiles = this.withoutSeen(tiles);

        if (tiles.length === 0) {
          this.shown = this.total;
          return this.render(true);
        }

        this.grid.append(...tiles);
        this.shown += tiles.length;
        this.phase = next.phase;
        this.page = next.page;
        this.render();
      } catch (error) {
        if (button) button.removeAttribute('aria-busy');
      } finally {
        this.loading = false;
      }
    }

    // Belt and braces: a filtered listing can shift under us between requests,
    // so never append a product that is already on the page.
    withoutSeen(tiles) {
      if (!this.seen) {
        this.seen = new Set();
        this.grid.querySelectorAll('.tile__title a').forEach((a) => this.seen.add(a.getAttribute('href')));
      }
      return tiles.filter((tile) => {
        const href = tile.querySelector('.tile__title a')?.getAttribute('href');
        if (!href || this.seen.has(href)) return false;
        this.seen.add(href);
        return true;
      });
    }

    render(done) {
      const footer = this.root.querySelector('.more');
      if (!footer) return;

      const finished = done || this.shown >= this.total;
      const bar = footer.querySelector('.more__bar > span');
      const label = footer.querySelector('.more__count');
      const button = footer.querySelector('[data-load-more]');

      if (bar) bar.style.width = Math.min(100, (this.shown / this.total) * 100) + '%';
      if (label) label.textContent = label.dataset.template
        ? label.dataset.template.replace('[shown]', this.shown).replace('[total]', this.total)
        : this.shown + ' / ' + this.total;

      if (!button) return;
      if (finished) {
        button.remove();
      } else if (!button.dataset.chained) {
        button.dataset.chained = 'true';
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.loadMore();
        });
      }
      button.removeAttribute('aria-busy');
    }
  }

  function initFilterSheet() {
    const sheet = document.querySelector('.listing__filters');
    const opener = document.querySelector('[data-sheet-open]');
    if (!sheet || !opener || sheet.dataset.ready) return;
    sheet.dataset.ready = 'true';

    const setOpen = (open) => {
      sheet.toggleAttribute('data-open', open);
      opener.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) {
        const close = sheet.querySelector('[data-sheet-close]');
        if (close) close.focus();
      } else {
        opener.focus();
      }
    };

    opener.addEventListener('click', () => setOpen(true));
    sheet.querySelectorAll('[data-sheet-close]').forEach((el) => el.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && sheet.hasAttribute('data-open')) setOpen(false);
    });
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 750 && sheet.hasAttribute('data-open')) setOpen(false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { enhanceCollection(); initFilterSheet(); });
  } else {
    enhanceCollection();
    initFilterSheet();
  }
  document.addEventListener('shopify:section:load', (event) => {
    enhanceCollection(event.target);
    initFilterSheet();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Drawer: focus is trapped while open and the page behind is locked, so the
  // menu behaves like the dialog it is rather than a panel you can scroll past.
  function initDrawer() {
    const drawer = document.querySelector('[data-drawer]');
    const opener = document.querySelector('[data-drawer-open]');
    if (!drawer || !opener || drawer.dataset.ready) return;
    drawer.dataset.ready = 'true';

    const panel = drawer.querySelector('.drawer__panel');
    let lastFocused = null;

    const setOpen = (open) => {
      drawer.hidden = !open;
      opener.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) {
        lastFocused = document.activeElement;
        const target = panel.querySelector('.drawer__close');
        if (target) target.focus();
      } else if (lastFocused) {
        lastFocused.focus();
      }
    };

    opener.addEventListener('click', () => setOpen(true));
    drawer.querySelectorAll('[data-drawer-close]').forEach((el) => {
      el.addEventListener('click', () => setOpen(false));
    });

    document.addEventListener('keydown', (event) => {
      if (drawer.hidden) return;
      if (event.key === 'Escape') {
        setOpen(false);
        return;
      }
      if (event.key !== 'Tab') return;

      const focusable = panel.querySelectorAll('a[href], button, input');
      if (focusable.length === 0) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        last.focus();
        event.preventDefault();
      } else if (!event.shiftKey && document.activeElement === last) {
        first.focus();
        event.preventDefault();
      }
    });

    // Crossing the breakpoint must not leave the page scroll-locked.
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 750 && !drawer.hidden) setOpen(false);
    });
  }

  function initStickyHeader() {
    const header = document.querySelector('[data-hide-on-scroll]');
    if (!header || header.dataset.stickyReady) return;
    header.dataset.stickyReady = 'true';

    let lastY = window.scrollY;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      // Only hide once past the header itself, and always reveal on scroll up.
      header.classList.toggle('header--hidden', y > lastY && y > 160);
      lastY = y;
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { initDrawer(); initStickyHeader(); });
  } else {
    initDrawer();
    initStickyHeader();
  }
  document.addEventListener('shopify:section:load', () => { initDrawer(); initStickyHeader(); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  class HeroBanner {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-hero-track]');
      this.dots = Array.from(root.querySelectorAll('[data-hero-dot]'));
      if (!this.track) return;

      const prev = root.querySelector('[data-hero-prev]');
      const next = root.querySelector('[data-hero-next]');

      if (prev) prev.addEventListener('click', () => this.step(-1));
      if (next) next.addEventListener('click', () => this.step(1));

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.goTo(Number(dot.dataset.heroDot)));
      });

      // Arrow keys drive the slider whenever focus is anywhere inside it, which
      // is what the carousel role leads a screen reader user to expect.
      root.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          this.step(-1);
          event.preventDefault();
        } else if (event.key === 'ArrowRight') {
          this.step(1);
          event.preventDefault();
        }
      });

      // Scroll position is the single source of truth, so dragging, arrows and
      // dot clicks all converge on the same active index.
      this.track.addEventListener('scroll', () => {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.sync());
      });

      this.sync();
    }

    get index() {
      const width = this.track.clientWidth;
      return width ? Math.round(this.track.scrollLeft / width) : 0;
    }

    get count() {
      return this.track.children.length;
    }

    goTo(index) {
      const target = (index + this.count) % this.count;
      this.track.scrollTo({ left: target * this.track.clientWidth });
    }

    step(delta) {
      this.goTo(this.index + delta);
    }

    sync() {
      const active = this.index;
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('hero__dot--active', i === active);
        dot.setAttribute('aria-current', i === active ? 'true' : 'false');
      });
    }
  }

  function initHeroBanners(scope) {
    (scope || document).querySelectorAll('[data-hero]').forEach((root) => {
      if (root.dataset.heroReady) return;
      root.dataset.heroReady = 'true';
      new HeroBanner(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initHeroBanners());
  } else {
    initHeroBanners();
  }

  // Re-bind when the theme editor swaps the section back in.
  document.addEventListener('shopify:section:load', (event) => initHeroBanners(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["impact-text"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-impact-count]').forEach((el) => {
    if (el.dataset.ready) return;
    el.dataset.ready = 'true';

    const target = parseFloat(String(el.dataset.target).replace(/[^\d.]/g, ''));
    if (!target || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const suffix = String(el.dataset.target).replace(/[\d.,\s]/g, '');
    const started = { done: false };

    const run = () => {
      if (started.done) return;
      started.done = true;
      const t0 = performance.now();
      const duration = 1200;
      const tick = (now) => {
        const p = Math.min((now - t0) / duration, 1);
        const eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased).toLocaleString('tr-TR') + suffix;
        if (p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };

    new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { run(); obs.disconnect(); }
      });
    }, { threshold: 0.4 }).observe(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"]) return;
  try {
    
  document.querySelectorAll('[data-popup]').forEach((popup) => {
    if (popup.dataset.ready) return;
    popup.dataset.ready = 'true';

    const key = 'mutant:popup:' + popup.dataset.sectionId;
    const frequencyMs = Number(popup.dataset.frequency) * 24 * 60 * 60 * 1000;
    const panel = popup.querySelector('.popup__panel');
    let opener = null;

    const dismissed = () => {
      try {
        const ts = Number(localStorage.getItem(key));
        return ts && Date.now() - ts < frequencyMs;
      } catch (error) {
        return false;
      }
    };

    const remember = () => {
      try {
        localStorage.setItem(key, String(Date.now()));
      } catch (error) {
        /* Storage unavailable — the popup simply shows again next visit. */
      }
    };

    const setOpen = (open, persist) => {
      popup.hidden = !open;
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) {
        opener = document.activeElement;
        panel.focus();
      } else {
        if (persist) remember();
        if (opener && opener.focus) opener.focus();
      }
    };

    popup.querySelectorAll('[data-popup-close]').forEach((el) => {
      el.addEventListener('click', () => setOpen(false, true));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !popup.hidden) setOpen(false, true);
    });

    // A submitted form (success or errors) reopens immediately so the visitor
    // sees the outcome; a successful signup is also remembered so the popup
    // retires for the full frequency window.
    const posted = popup.querySelector('[data-popup-posted]');

    if (posted) {
      if (popup.querySelector('.popup__note--success')) remember();
      setOpen(true);
    } else if (!popup.hasAttribute('data-disabled') && !dismissed() && !window.Shopify?.designMode) {
      setTimeout(() => {
        if (popup.hidden) setOpen(true);
      }, Number(popup.dataset.delay));
    }

    // Theme editor: preview while the section is selected.
    document.addEventListener('shopify:section:select', (event) => {
      if (event.target.contains(popup)) setOpen(true);
    });
    document.addEventListener('shopify:section:deselect', (event) => {
      if (event.target.contains(popup)) setOpen(false);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details"]) return;
  try {
    
  // Read more / read less. The rail and its scroll-spy stay as they are: the
  // headings only become reachable once the copy is open, which is also when
  // the rail starts being useful.
  function initDetailsMore() {
    document.querySelectorAll('[data-details-more]').forEach((button) => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';

      const root = button.closest('.details__column');
      const clamp = root.querySelector('[data-details-clamp]');
      const label = button.querySelector('[data-details-more-label]');
      const openLabel = label.textContent;
      const closeLabel = button.dataset.closeLabel;

      button.addEventListener('click', () => {
        const closed = clamp.classList.toggle('details__clamp--closed');
        button.setAttribute('aria-expanded', closed ? 'false' : 'true');
        label.textContent = closed ? openLabel : closeLabel;

        // Collapsing from far down the copy would otherwise leave the reader
        // stranded below the section; bring the heading back into view.
        if (closed) {
          root.closest('.details').scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDetailsMore);
  } else {
    initDetailsMore();
  }
  document.addEventListener('shopify:section:load', initDetailsMore);

  // Scoped to this section rather than shared with the article template: the
  // generated stylesheet and script bundles are global, so two sections reading
  // the same hooks would silently depend on each other's files.
  function buildProductDetailsToc() {
    const band = document.querySelector('.details');
    const rail = document.querySelector('[data-details-rail]');
    const list = document.querySelector('[data-details-toc]');
    const body = document.querySelector('[data-details-body]');
    if (!band || !rail || !list || !body || band.dataset.ready) return;
    band.dataset.ready = 'true';

    const headings = Array.from(body.querySelectorAll('h2, h3'));
    if (headings.length < 2) {
      band.classList.add('details--plain');
      return;
    }

    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = 'detail-' + index;
      const link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent.trim();
      if (heading.tagName === 'H3') link.style.paddingLeft = '20px';
      list.appendChild(link);
    });

    rail.hidden = false;

    // On mobile the rail is a disclosure; on desktop it is always open.
    const toggle = rail.querySelector('[data-details-toggle]');
    if (toggle) {
      const setOpen = (open) => {
        rail.toggleAttribute('data-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        const sign = toggle.querySelector('.details__chevron');
        if (sign) sign.textContent = open ? '\u2212' : '+';
      };
      setOpen(window.innerWidth >= 750);
      toggle.addEventListener('click', () => setOpen(!rail.hasAttribute('data-open')));
      toggle.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setOpen(!rail.hasAttribute('data-open'));
        }
      });
    }

    // IntersectionObserver only fires while a heading sits inside a narrow
    // band, so nothing was marked whenever the reader was between two of them.
    // Tracking the last heading scrolled past always resolves to exactly one.
    const links = Array.from(list.querySelectorAll('a'));
    const markCurrent = () => {
      let activeIndex = 0;
      headings.forEach((heading, index) => {
        if (heading.getBoundingClientRect().top <= 120) activeIndex = index;
      });
      links.forEach((link, index) => {
        link.classList.toggle('details__toc--current', index === activeIndex);
      });
      const active = links[activeIndex];
      if (active && active.offsetParent) {
        const rail = active.parentElement;
        const top = active.offsetTop - rail.clientHeight / 2;
        if (rail.scrollHeight > rail.clientHeight) rail.scrollTo({ top, behavior: 'smooth' });
      }
    };

    document.addEventListener('scroll', markCurrent, { passive: true });
    markCurrent();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildProductDetailsToc);
  } else {
    buildProductDetailsToc();
  }
  document.addEventListener('shopify:section:load', buildProductDetailsToc);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  function enhanceProduct(scope) {
    const root = scope || document;

    const gallery = root.querySelector('[data-gallery]');
    if (gallery && !gallery.dataset.ready) {
      gallery.dataset.ready = 'true';
      gallery.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-thumb]');
        if (!thumb) return;
        const id = thumb.dataset.thumb;

        gallery.querySelectorAll('[data-thumb]').forEach((t) => {
          const on = t === thumb;
          t.classList.toggle('gallery__thumb--active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        gallery.querySelectorAll('[data-slide]').forEach((s) => {
          s.classList.toggle('gallery__slide--active', s.dataset.slide === id);
        });
      });
    }

    const form = root.querySelector('.buy__form');
    if (form && !form.dataset.ready) {
      form.dataset.ready = 'true';

      form.addEventListener('click', (event) => {
        const button = event.target.closest('[data-step]');
        if (!button) return;
        const input = form.querySelector('#pdp-qty');
        const next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(button.dataset.step, 10));
        input.value = next;
      });

      // Keep the headline price in step with the chosen package. The radio is
      // the real form control, so this is display only — submitting without
      // script still posts the right variant.
      form.addEventListener('change', (event) => {
        const radio = event.target.closest('.pack__input');
        if (!radio) return;
        const price = form.querySelector('[data-price]');
        if (price) price.textContent = radio.dataset.price;
        const transfer = form.querySelector('[data-transfer]');
        if (transfer && radio.dataset.transfer) transfer.textContent = radio.dataset.transfer;

        const compare = form.querySelector('[data-compare]');
        if (compare) {
          const hasCompare = radio.dataset.compare && radio.dataset.compare !== radio.dataset.price;
          compare.hidden = !hasCompare;
          if (hasCompare) compare.textContent = radio.dataset.compare;
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhanceProduct());
  } else {
    enhanceProduct();
  }
  document.addEventListener('shopify:section:load', (event) => enhanceProduct(event.target));

  // Mobile gallery: a scroll-snap carousel whose counter follows the scroll
  // position, plus the buy bar that appears once the panel's button is gone.
  function initProductMobile() {
    const stage = document.querySelector('[data-gallery-stage]');
    const counter = document.querySelector('[data-gallery-counter]');
    if (stage && counter && !stage.dataset.mobileReady) {
      stage.dataset.mobileReady = 'true';
      const slides = stage.querySelectorAll('[data-slide]');
      stage.addEventListener('scroll', () => {
        const width = stage.clientWidth;
        if (!width) return;
        const index = Math.round(stage.scrollLeft / width) + 1;
        counter.textContent = index + ' / ' + slides.length;
      }, { passive: true });
    }

    const bar = document.querySelector('[data-buybar]');
    const form = document.querySelector('.buy__form');
    const anchor = document.querySelector('.buy__add');
    if (!bar || !form || !anchor || bar.dataset.ready) return;
    bar.dataset.ready = 'true';

    bar.querySelector('[data-buybar-submit]').addEventListener('click', () => {
      if (form.requestSubmit) form.requestSubmit(anchor);
      else form.submit();
    });

    // Keep the bar's figures in step with the chosen package.
    form.addEventListener('change', (event) => {
      const radio = event.target.closest('.pack__input');
      if (!radio) return;
      const price = bar.querySelector('[data-buybar-price]');
      if (price && radio.dataset.price) price.textContent = radio.dataset.price;
      const transfer = bar.querySelector('[data-buybar-transfer]');
      if (transfer && radio.dataset.transfer) transfer.textContent = radio.dataset.transfer;
    });

    // Only show it once the real button has left the screen, so the two are
    // never on screen together.
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((entry) => { bar.hidden = entry.isIntersecting; }),
      { rootMargin: '0px 0px -80px 0px' }
    );
    observer.observe(anchor);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductMobile);
  } else {
    initProductMobile();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["set-builder"] && !Shopify.designMode) return;
  try {
    
  // Formats cents with the shop's own money format, so the preview reads the
  // same as the cart and checkout.
  function setbMoney(cents, format) {
    const value = (Number(cents) || 0) / 100;
    const fmt = format || '{' + '{amount}}';
    const group = (n, decimals, thousands, decimal) => {
      const parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => {
      switch (key) {
        case 'amount_no_decimals': return group(value, 0, ',', '.');
        case 'amount_with_comma_separator': return group(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(value, 2, "'", '.');
        default: return group(value, 2, ',', '.');
      }
    });
  }

  if (!customElements.get('set-builder')) {
    class SetBuilder extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.min = parseInt(this.dataset.min, 10) || 2;
        this.max = parseInt(this.dataset.max, 10) || 4;
        this.tiers = (this.dataset.tiers || '0,10,15,20').split(',').map((n) => parseInt(n, 10) || 0);
        this.format = this.dataset.moneyFormat;
        try {
          this.strings = JSON.parse(this.querySelector('[data-set-strings]').textContent);
        } catch (e) {
          this.strings = {};
        }
        this.selected = [];

        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.selectTab(i));
          tab.addEventListener('keydown', (e) => {
            const n = this.tabs.length;
            let to = null;
            if (e.key === 'ArrowRight') to = (i + 1) % n;
            if (e.key === 'ArrowLeft') to = (i - 1 + n) % n;
            if (e.key === 'Home') to = 0;
            if (e.key === 'End') to = n - 1;
            if (to === null) return;
            e.preventDefault();
            this.selectTab(to);
            this.tabs[to].focus();
          });
        });

        this.addEventListener('click', (e) => {
          // The button or the product photo toggles the pick
          const toggle = e.target.closest('[data-set-toggle], .setb-card__media');
          if (toggle) return this.toggle(toggle.closest('[data-set-card]'));
          const remove = e.target.closest('[data-set-remove]');
          if (remove) return this.remove(remove.dataset.setRemove);
          if (e.target.closest('[data-set-submit]')) this.submit();
        });
        this.addEventListener('change', (e) => {
          if (e.target.matches('[data-set-variant]')) this.changeVariant(e.target);
        });
        this.search = this.querySelector('[data-set-search]');
        if (this.search) this.search.addEventListener('input', () => this.filter());

        // Long collections are split into numbered pages (the selection survives page changes).
        this.pageSize = parseInt(this.dataset.pageSize, 10) || 0;
        this.querySelectorAll('.setb__panel').forEach((panel) => {
          panel.dataset.page = '1';
          const pager = panel.querySelector('[data-set-pager]');
          if (pager) {
            pager.setAttribute('aria-label', this.strings.pagerLabel || '');
            pager.addEventListener('click', (e) => {
              const btn = e.target.closest('[data-goto]');
              if (!btn || btn.disabled) return;
              panel.dataset.page = btn.dataset.goto;
              this.paginate(panel);
              const top = panel.getBoundingClientRect().top + window.scrollY - 120;
              if (panel.getBoundingClientRect().top < 0) window.scrollTo({ top, behavior: 'smooth' });
            });
          }
          this.paginate(panel);
        });

        this.render();
        this.loadEdit();
      }

      t(key, vars = {}) {
        return Object.keys(vars).reduce((s, k) => s.split(`[${k}]`).join(vars[k]), this.strings[key] || '');
      }

      money(cents) {
        return setbMoney(cents, this.format);
      }

      percentFor(count) {
        return this.tiers[Math.min(count, this.tiers.length) - 1] || 0;
      }

      nextTier(count) {
        for (let k = count + 1; k <= this.max; k++) {
          const p = this.percentFor(k);
          if (p > this.percentFor(count)) return { count: k, percent: p };
        }
        return null;
      }

      selectTab(i) {
        this.tabs.forEach((tab, k) => {
          const on = k === i;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
          const panel = document.getElementById(tab.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }

      // The cart's "SETİ DÜZENLE" stores the set; preselect it here and replace
      // the old lines when the new set is added.
      loadEdit() {
        let data = null;
        try {
          data = JSON.parse(sessionStorage.getItem('cpl-set-edit') || 'null');
          sessionStorage.removeItem('cpl-set-edit');
        } catch (e) {
          data = null;
        }
        if (!data || !data.id) return;
        this.editId = data.id;
        this.editQty = Math.max(1, parseInt(data.qty, 10) || 1);
        this.selected = [];
        const cards = Array.from(this.querySelectorAll('[data-set-card]'));
        (data.variants || []).forEach((variantId) => {
          if (this.selected.length >= this.max) return;
          const card = cards.find((c) => {
            if (c.dataset.variant === String(variantId)) return true;
            const select = c.querySelector('[data-set-variant]');
            return select && Array.from(select.options).some((o) => o.value === String(variantId));
          });
          if (!card || this.selected.some((s) => s.product === card.dataset.product)) return;
          const select = card.querySelector('[data-set-variant]');
          if (select) {
            select.value = String(variantId);
            this.changeVariant(select);
          }
          this.selected.push(this.cardData(card));
        });
        this.render();
      }

      // Shows one page of the matching cards and redraws the numbered pager.
      paginate(panel) {
        const pager = panel.querySelector('[data-set-pager]');
        const cards = Array.from(panel.querySelectorAll('[data-set-card]')).filter((c) => !c.hidden);
        const size = this.pageSize > 0 ? this.pageSize : cards.length || 1;
        const pages = Math.max(1, Math.ceil(cards.length / size));
        const page = Math.min(Math.max(1, Number(panel.dataset.page) || 1), pages);
        panel.dataset.page = String(page);
        cards.forEach((card, i) => card.classList.toggle('is-paged', i < (page - 1) * size || i >= page * size));
        if (!pager) return;
        pager.hidden = pages < 2;
        pager.replaceChildren();
        if (pages < 2) return;
        const button = (label, goto, cls, aria, disabled) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = cls;
          b.textContent = label;
          b.dataset.goto = String(goto);
          if (aria) b.setAttribute('aria-label', aria);
          if (disabled) b.disabled = true;
          return b;
        };
        pager.append(button('←', page - 1, `pager__step${page <= 1 ? ' pager__step--off' : ''}`, this.strings.previous, page <= 1));
        // First, last and the neighbours of the current page; the rest collapse to …
        const windowed = (pages, page) => {
          const keep = new Set([1, pages, page - 1, page, page + 1]);
          const out = [];
          for (let n = 1; n <= pages; n++) {
            if (keep.has(n)) out.push(n);
            else if (out[out.length - 1] !== '…') out.push('…');
          }
          return out;
        };
        windowed(pages, page).forEach((n) => {
          if (n === '…') {
            const gap = document.createElement('span');
            gap.className = 'pager__gap';
            gap.setAttribute('aria-hidden', 'true');
            gap.textContent = '…';
            pager.append(gap);
            return;
          }
          const current = n === page;
          const b = button(String(n), n, `pager__page${current ? ' pager__page--current' : ''}`, `${this.strings.page || ''}${n}`);
          if (current) b.setAttribute('aria-current', 'page');
          pager.append(b);
        });
        pager.append(button('→', page + 1, `pager__step${page >= pages ? ' pager__step--off' : ''}`, this.strings.next, page >= pages));
      }

      filter() {
        const norm = (s) =>
          String(s || '')
            .toLocaleLowerCase('tr')
            .replace(/ı/g, 'i')
            .replace(/ş/g, 's')
            .replace(/ğ/g, 'g')
            .replace(/ü/g, 'u')
            .replace(/ö/g, 'o')
            .replace(/ç/g, 'c');
        const q = norm(this.search.value.trim());
        this.querySelectorAll('.setb__panel').forEach((panel) => {
          panel.dataset.page = '1';
          let shown = 0;
          panel.querySelectorAll('[data-set-card]').forEach((card) => {
            const hit = !q || norm(card.dataset.title).includes(q);
            card.hidden = !hit;
            if (hit) shown += 1;
          });
          const none = panel.querySelector('[data-set-noresult]');
          if (none) none.hidden = shown > 0;
          this.paginate(panel);
        });
      }

      cardData(card) {
        const select = card.querySelector('[data-set-variant]');
        const option = select ? select.selectedOptions[0] : null;
        return {
          product: card.dataset.product,
          variant: Number(option ? option.value : card.dataset.variant),
          price: Number(option ? option.dataset.price : card.dataset.price) || 0,
          title: card.dataset.title,
          image: (option && option.dataset.image) || card.dataset.image || '',
        };
      }

      toggle(card) {
        if (!card) return;
        const id = card.dataset.product;
        if (this.selected.some((s) => s.product === id)) return this.remove(id);
        if (this.selected.length >= this.max) return;
        this.selected.push(this.cardData(card));
        this.render();
      }

      remove(id) {
        this.selected = this.selected.filter((s) => s.product !== id);
        this.render();
      }

      changeVariant(select) {
        const card = select.closest('[data-set-card]');
        const option = select.selectedOptions[0];
        this.querySelectorAll(`[data-set-card][data-product="${card.dataset.product}"]`).forEach((other) => {
          const s = other.querySelector('[data-set-variant]');
          if (s && s !== select) s.value = select.value;
          const p = other.querySelector('[data-set-price]');
          if (p && option) p.textContent = this.money(option.dataset.price);
        });
        const i = this.selected.findIndex((s) => s.product === card.dataset.product);
        if (i > -1) {
          this.selected[i] = this.cardData(card);
          this.render();
        }
      }

      render() {
        const n = this.selected.length;
        const full = n >= this.max;
        const ids = new Set(this.selected.map((s) => s.product));

        this.querySelectorAll('[data-set-card]').forEach((card) => {
          const on = ids.has(card.dataset.product);
          const btn = card.querySelector('[data-set-toggle]');
          card.classList.toggle('is-selected', on);
          if (!btn) return;
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          btn.disabled = !on && full;
          btn.querySelector('[data-set-toggle-label]').textContent = on
            ? this.strings.added
            : full
              ? this.strings.full
              : this.strings.add;
        });

        const percent = n >= this.min ? this.percentFor(n) : 0;
        this.querySelectorAll('[data-tier]').forEach((el) => {
          const k = Number(el.dataset.tier);
          el.classList.toggle('is-reached', n >= k && n > 0);
          el.classList.toggle('is-active', n === k);
        });

        this.querySelectorAll('[data-slot]').forEach((slot, i) => {
          const item = this.selected[i];
          slot.classList.toggle('is-filled', !!item);
          slot.replaceChildren();
          if (!item) {
            const num = document.createElement('span');
            num.className = 'setb-slot__num display';
            num.setAttribute('aria-hidden', 'true');
            num.textContent = i + 1;
            slot.append(num);
            return;
          }
          if (item.image) {
            const img = document.createElement('img');
            img.src = item.image;
            img.alt = '';
            img.width = 80;
            img.height = 80;
            slot.append(img);
          }
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'setb-slot__remove';
          btn.dataset.setRemove = item.product;
          btn.setAttribute('aria-label', this.t('remove', { product: item.title }));
          btn.textContent = '×';
          slot.append(btn);
        });

        let msg;
        const next = this.nextTier(n);
        if (n === 0) msg = this.editId ? this.strings.editing : this.strings.msgStart;
        else if (n < this.min) msg = this.t('msgMore', { count: this.min - n, percent: this.percentFor(this.min) });
        else if (next) msg = this.t('msgNext', { percent, count: next.count - n, next: next.percent });
        else msg = this.t('msgFull', { percent });
        const msgEl = this.querySelector('[data-set-msg]');
        if (msgEl && msgEl.textContent !== msg) msgEl.textContent = msg;

        const set = (sel, text) => {
          const el = this.querySelector(sel);
          if (el) el.textContent = text;
        };
        const progress = this.querySelector('[data-set-progress]');
        if (progress) progress.style.width = `${Math.min(100, (n / this.max) * 100)}%`;
        set('[data-set-count]', this.t('count', { count: n }));

        const subtotal = this.selected.reduce((sum, s) => sum + s.price, 0);
        const discount = Math.round((subtotal * percent) / 100);
        set('[data-set-subtotal]', this.money(subtotal));
        set('[data-set-discount-label]', this.t('discount', { percent }));
        set('[data-set-discount]', `−${this.money(discount)}`);
        set('[data-set-total]', this.money(subtotal - discount));
        const submit = this.querySelector('[data-set-submit]');
        if (submit) submit.disabled = n < this.min;
      }

      async submit() {
        const n = this.selected.length;
        if (n < this.min) return;
        const btn = this.querySelector('[data-set-submit]');
        if (btn.getAttribute('aria-busy') === 'true') return;
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;

        const root = window.Shopify.routes.root;
        const setId = `S${Date.now().toString(36).toUpperCase()}`;
        const percent = this.percentFor(n);
        const items = this.selected.map((s) => ({
          id: s.variant,
          quantity: this.editId ? this.editQty : 1,
          properties: { _cpl_set: setId, _cpl_set_size: String(n), _cpl_set_discount: String(percent) },
        }));

        try {
          if (this.editId) {
            const cart = await (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })).json();
            const updates = {};
            (cart.items || []).forEach((item) => {
              if (item.properties && item.properties._cpl_set === this.editId) updates[item.key] = 0;
            });
            if (Object.keys(updates).length) {
              await fetch(`${root}cart/update.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ updates }),
              });
            }
            this.editId = null;
            this.editQty = 1;
          }
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          if (!response.ok) throw new Error((await response.json()).description || '');
          this.selected = [];
          this.render();
          // The drawer listens for this and re-renders itself from the server.
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
          if (!document.querySelector('[data-cart-drawer]')) window.location.href = `${root}cart`;
        } catch (err) {
          const msgEl = this.querySelector('[data-set-msg]');
          if (msgEl) msgEl.textContent = (err && err.message) || this.strings.error;
        } finally {
          btn.removeAttribute('aria-busy');
          this.render();
        }
      }
    }
    customElements.define('set-builder', SetBuilder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-slides]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';

    const items = root.querySelectorAll('[data-slide-item]');
    if (items.length < 2) return;

    const dots = root.querySelectorAll('[data-slide-dot]');
    let index = 0;
    let timer = null;

    const show = (next) => {
      index = (next + items.length) % items.length;
      items.forEach((el, i) => el.classList.toggle('slide-item--active', i === index));
      dots.forEach((el, i) => el.classList.toggle('slides__dot--active', i === index));
    };

    const stop = () => timer && clearInterval(timer);
    const start = () => {
      if (root.dataset.autoplay !== 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      stop();
      timer = setInterval(() => show(index + 1), Number(root.dataset.interval) || 6000);
    };

    root.querySelector('[data-slide-prev]').addEventListener('click', () => { show(index - 1); start(); });
    root.querySelector('[data-slide-next]').addEventListener('click', () => { show(index + 1); start(); });
    dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.slideDot)); start(); }));

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    start();
  });

  } catch(e) { console.error(e); }
})();
})();
